import { ACTIVE_ENV } from './environments.js'

const DEFAULT_ROLES = {
    SUPER_ADMIN: '5',
    ADMIN: '1',
    EXT_OPS: '8',
    MAINTENANCE: '3',
    ANALYTICS: '7',
    DEVICE_CONFIGURATION_MANAGER: '4',
    INSURANCE: '48'
}

const ROLE_MAPS = {
    'DEV': {
        SUPER_ADMIN: '1001',
        ADMIN: '1000',
        EXT_OPS: '2005',
        MAINTENANCE: '2003',
        ANALYTICS: '2004',
        DEVICE_CONFIGURATION_MANAGER: '2001',
        INSURANCE: '2007'
    },
    'QA': {
        INSURANCE: '48'
    },
    'UAT': {
        INSURANCE: '44'
    },
    'PROD': {
        INSURANCE: '37'
    }
}

const envRoles = ROLE_MAPS[ACTIVE_ENV] || {};

export const SUPER_ADMIN = envRoles.SUPER_ADMIN || DEFAULT_ROLES.SUPER_ADMIN;
export const ADMIN = envRoles.ADMIN || DEFAULT_ROLES.ADMIN;
export const EXT_OPS = envRoles.EXT_OPS || DEFAULT_ROLES.EXT_OPS;
export const MAINTENANCE = envRoles.MAINTENANCE || DEFAULT_ROLES.MAINTENANCE;
export const ANALYTICS = envRoles.ANALYTICS || DEFAULT_ROLES.ANALYTICS;
export const DEVICE_CONFIGURATION_MANAGER = envRoles.DEVICE_CONFIGURATION_MANAGER || DEFAULT_ROLES.DEVICE_CONFIGURATION_MANAGER;
export const INSURANCE = envRoles.INSURANCE || DEFAULT_ROLES.INSURANCE;
